import { render, staticRenderFns } from "./card-orders-result.vue?vue&type=template&id=d8f8a68c&"
import script from "./card-orders-result.vue?vue&type=script&lang=js&"
export * from "./card-orders-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports